// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","457":"7c5a3420","732":"fda73a07","851":"59466e1d","977":"30ebfe98"}[chunkId] + ".chunk.js";
};